// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VFFJ5e {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-right: var(--spacing-3);
  padding-left: var(--spacing-3);
  height: 64px;
  width: 100%;
  border-bottom: 1px solid var(--stroke-neutral-subtle);
  gap: var(--spacing-4);
}

.Ay3Q4f {
  position: relative;
  height: 100%;
}

.P5KwP_ {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
  text-decoration: none;
  transition: color 0.2s;
  border-bottom: 2px solid transparent;
}

.dWzuVR {
  color: var(--stroke-primary-medium);
  border-bottom: 2px solid var(--stroke-primary-medium);
}

.n4kFyV {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  display: none;
  min-width: 260px;
  background: #fff;
  border: 1px solid var(--stroke-neutral-subtle);
  border-radius: 8px;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);
  padding: 8px 0;
  z-index: 1301;

  list-style: none;
  margin: 0;
}

.n4kFyV.D9o214 {
  display: block;
}

.HtGXQ4 {
  display: block;
  padding: 12px 16px;
  text-decoration: none;
  color: var(--text-neutral-dark);
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
}

.HtGXQ4:hover {
  background: var(--surface-neutral-soft, #f7f7f7);
}

.hhYxAY {
  color: var(--stroke-primary-medium);
}

.n4kFyV .dWzuVR {
  border-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/NavBar/NavBar.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,+BAA+B;EAC/B,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,qDAAqD;EACrD,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;EAC/B,qBAAqB;EACrB,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;EAClB,2CAA2C;EAC3C,cAAc;EACd,aAAa;;EAEb,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,+BAA+B;EAC/B,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".navBar {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding-right: var(--spacing-3);\n  padding-left: var(--spacing-3);\n  height: 64px;\n  width: 100%;\n  border-bottom: 1px solid var(--stroke-neutral-subtle);\n  gap: var(--spacing-4);\n}\n\n.navItem {\n  position: relative;\n  height: 100%;\n}\n\n.navLink {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n  text-decoration: none;\n  transition: color 0.2s;\n  border-bottom: 2px solid transparent;\n}\n\n.activeTab {\n  color: var(--stroke-primary-medium);\n  border-bottom: 2px solid var(--stroke-primary-medium);\n}\n\n.submenu {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  display: none;\n  min-width: 260px;\n  background: #fff;\n  border: 1px solid var(--stroke-neutral-subtle);\n  border-radius: 8px;\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);\n  padding: 8px 0;\n  z-index: 1301;\n\n  list-style: none;\n  margin: 0;\n}\n\n.submenu.open {\n  display: block;\n}\n\n.submenuItem {\n  display: block;\n  padding: 12px 16px;\n  text-decoration: none;\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n}\n\n.submenuItem:hover {\n  background: var(--surface-neutral-soft, #f7f7f7);\n}\n\n.submenuItemActive {\n  color: var(--stroke-primary-medium);\n}\n\n.submenu .activeTab {\n  border-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navBar": `VFFJ5e`,
	"navItem": `Ay3Q4f`,
	"navLink": `P5KwP_`,
	"activeTab": `dWzuVR`,
	"submenu": `n4kFyV`,
	"open": `D9o214`,
	"submenuItem": `HtGXQ4`,
	"submenuItemActive": `hhYxAY`
};
module.exports = ___CSS_LOADER_EXPORT___;
